import { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  useMediaQuery,
  Menu,
  MenuItem,
} from "@mui/material";
import { useLocation } from "react-router";
import {
  navbar,
  navbarRow,
  navbarMobileMenu,
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "./styles";
import {
  NotificationAdd,
  Search as SearchIcon,
  Error,
  MenuOpen,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { useBTUIController, setMiniSidenav } from "../../context";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BTBox from "../../components/BTBox";
import BTButton from "../../components/BTButton";
import BTBadge from "../../components/BTBadge";
import useRoutes from "../../routes";
import { NavLink } from "react-router";
import Addconversion from "../../Pages/Masters/coversationrate/Addconversion";
import moment from "moment";
import { useSelector } from "react-redux";
import { get_cnv_rates } from "../../store/functions";
const MenuContent = ({ pages, anchorEl, handleMenuClose }) => {
  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.10))",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 40,
            height: 40,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            left: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "left", vertical: "top" }}
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
    >
      {pages?.map((item) => (
        <MenuItem
          key={item?.key}
          component={!item?.subItems ? NavLink : undefined}
          to={!item?.subItems ? item?.route : undefined}
          onClick={handleMenuClose}
          sx={{ fontSize: "0.9rem" }}
        >
          {item?.name}
        </MenuItem>
      ))}
    </Menu>
  );
};

function Dashboardnavbar({ absolute, light, sideNavWidth }) {
  const location = useLocation();
  const app_routes = useRoutes();
  const [state, dispatch] = useBTUIController();
  const { transparentNavbar, darkMode, fixedNavbar, miniSidenav } = state;
  const [open, setOpen] = useState(null);
  const conversionRate = useSelector((state) => state?.lab?.conversionRate);
  const [navbarType, setNavbarType] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(null);
  const isMobile = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    !conversionRate?.is_fetch && get_cnv_rates();
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }
  }, [fixedNavbar]);
  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleMenuOpen = (event, menu) => {
    if (menu?.subItems === false) {
      return;
    }
    setAnchorEl(event.currentTarget);
    setCurrentMenu(menu);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentMenu(null);
  };

  function getTodaysRate(rates) {
    const todayDate = moment().format("YYYY-MM-DD");
    const todaysRateObj = rates?.find((rate) => {
      const rateDate = moment(rate.cnv_date).format("YYYY-MM-DD");
      return rateDate === todayDate;
    });
    return todaysRateObj ? todaysRateObj.cnv_rate : 0;
  }
  const todaysRate = getTodaysRate(conversionRate?.data);

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => ({
        ...navbar(theme, { transparentNavbar, absolute, light, darkMode }),
        left: `${sideNavWidth}px`,
        transition: theme.transitions.create(["width", "left"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      })}
    >
      <Toolbar>
        {isMobile && miniSidenav ? (
          <BTBox sx={(theme) => navbarRow(theme, { isMobile })}>
            <BTBox color={light ? "white" : "inherit"}>
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                {miniSidenav ? <MenuIcon /> : <MenuOpen />}
              </IconButton>
            </BTBox>
          </BTBox>
        ) : null}

        {/* Menu content */}
        <BTBox
          sx={{
            flexGrow: 1,
            gap: 1,
            overflow: "auto",
            display: {
              xs: "none",
              sm: "none",
              lg: "flex",
              xl: "flex",
              md: "flex",
            },
          }}
        >
          {app_routes
            ?.filter(({ type }) => type === "collapse")
            ?.map((page) => (
              <BTButton
                key={page?.key}
                component={!page?.subItems ? NavLink : undefined}
                to={!page?.subItems ? page?.route : undefined}
                sx={{
                  gap: 1,
                  mx: 1,
                  p: 0,
                  borderRadius: 0,
                  "&.active": {
                    borderBottom: "1px solid gray",
                    p: 0,
                  },
                  "&:hover": {
                    borderBottom: "1px solid gray",
                  },
                }}
                className={
                  location.pathname === page?.route ||
                  page?.items?.some((item) => location.pathname === item.route)
                    ? "active"
                    : ""
                }
                onClick={(e) => handleMenuOpen(e, page)}
                variant={"contained"}
                aria-controls={
                  currentMenu?.name === page.name ? "basic-menu" : undefined
                }
                aria-haspopup="true"
                aria-expanded={
                  currentMenu?.name === page.name ? "true" : undefined
                }
              >
                {page?.name}
                {page?.subItems && (
                  <KeyboardArrowDownIcon
                    sx={(theme) => ({
                      rotate:
                        currentMenu?.name === page?.name ? "180deg" : "0deg",
                      transition: theme.transitions.create(["rotate"], {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.standard,
                      }),
                    })}
                  />
                )}
              </BTButton>
            ))}
        </BTBox>
        <MenuContent
          pages={currentMenu?.items}
          anchorEl={anchorEl}
          handleMenuClose={handleMenuClose}
        />
        {/* Last content left side  */}
        <BTBox
          display="flex"
          justifyContent="flex-end"
          gap={2}
          alignItems="center"
        >
          <BTBadge
            badgeContent={`Today Rate : ${Number(todaysRate)?.toFixed(2)}`}
            size="lg"
            variant={"gradient"}
            color={todaysRate === 0 ? "error" : "dark"}
            onClick={() => setOpen({ show: true, actionType: 1 })}
            showZero={true}
            max={1000000}
            container
          />
        </BTBox>
      </Toolbar>
      {Boolean(open) && (
        <Addconversion
          open={open}
          conversionRate={conversionRate}
          setOpen={setOpen}
        />
      )}
    </AppBar>
  );
}
export default Dashboardnavbar;
